import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sReportsControllerEndpoint = 'Reports';


export class ReportsAPI {

  getReport(reportType) {
    return axios.get(getBackendURL() + sReportsControllerEndpoint + '?reportType=' + reportType);
  }

}

export default ReportsAPI


// WEBPACK FOOTER //
// ./src/API/ReportsAPI.js